import { FaFilePdf } from 'react-icons/fa6';
import { FaFileWord } from 'react-icons/fa6';
import { FaFileExcel } from 'react-icons/fa6';
import { FaFileImage } from 'react-icons/fa6';
import { BsFiletypeTxt } from 'react-icons/bs';
import { AiOutlineFileUnknown } from 'react-icons/ai';

/**
 * Gets an emoji icon based on file name and MIME type
 */
export const getFileIcon = (
  fileName?: string,
  mimeType?: string,
): React.ReactNode => {
  if (!fileName && !mimeType) return '📄';

  const extension = fileName?.split('.').pop()?.toLowerCase() || '';
  const type = mimeType?.toLowerCase() || '';

  if (type.includes('pdf') || extension === 'pdf') return <FaFilePdf />;
  if (type.includes('word') || extension === 'doc' || extension === 'docx')
    return <FaFileWord />;
  if (type.includes('excel') || extension === 'xls' || extension === 'xlsx')
    return <FaFileExcel />;
  if (
    type.includes('image') ||
    ['jpg', 'jpeg', 'png', 'gif'].includes(extension)
  )
    return <FaFileImage />;
  if (type.includes('text') || extension === 'txt') return <BsFiletypeTxt />;

  return <AiOutlineFileUnknown />;
};
